module.exports = __webpack_public_path__ + "media/bootstrap-icons/table-91ef93d9.svg";